import LandingPage from "./LandingPage";
function App() {
  return (
    <div>
      <LandingPage></LandingPage>
    </div>
  );
}

export default App;
